import styled from "styled-components";

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  margin: 0 20px;
`;
